import { OfferFilterQueryRequest } from './offer-filter-query.request';
export const createMockOfferFilterQueryRequest = (customValues) => {
    const query = new OfferFilterQueryRequest();
    query.lang = customValues?.lang ?? 'ES';
    query.onlyActive = customValues?.onlyActive ?? false;
    query.roles = customValues?.roles ?? [1];
    query.techs = customValues?.techs ?? [2];
    query.text = customValues?.text ?? 'manfred';
    query.currency = customValues?.currency ?? '€';
    query.minSalaryInK = customValues?.minSalaryInK ?? 10;
    query.remoteOptions = customValues?.remoteOptions ?? ['remote'];
    query.locations = customValues?.locations ?? ['ChIJgTwKgJcpQg0RaSKMYcHeNsQ'];
    query.offerLanguage = customValues?.offerLanguage ?? 'ES';
    return query;
};
//# sourceMappingURL=offer-fllter-query.request.mock.js.map